import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

export default function MaintenanceView({ message }) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #eef2ff 0%, #fdf2f8 100%)',
        padding: 2
      }}
    >
      <Paper elevation={6} sx={{ maxWidth: 520, width: '100%', padding: 5, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
          {t('maintenance_active_title')}
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
          {message || t('maintenance_active_description')}
        </Typography>
        <Typography variant="body2" sx={{ mt: 3, color: 'text.disabled' }}>
          {t('maintenance_contact_support')}
        </Typography>
        <Button variant="contained" color="primary" sx={{ mt: 4 }} href="/login">
          {t('login')}
        </Button>
      </Paper>
    </Box>
  );
}
